import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface ConfirmationDialogData {
  message: string;
  title?: string;
  icon?: string;
  recordLabel?: string;
  recordName?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}
@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationDialogComponent {
  json: any;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | ConfirmationDialogData
    ) { }

get options(): ConfirmationDialogData {
    return typeof this.data === 'string' ? { message: this.data } : this.data;
  }

  get message(): string { return this.options.message; }

onNoClick(): void {
    this.dialogRef.close();
  }
}
